import { combineReducers } from 'redux';
import loginReducer from '../auth/reducer';
import ClinicReducer from '../Clinic/reducer'

export default combineReducers({
    loginReducer: loginReducer,
    clinicReducer: ClinicReducer
})